import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

import importedPlan from './stephen-plan-2023';

import { ExercisesProvider } from './../exercises/exercises';


@Injectable()
export class PlanProvider {

  constructor(
    private storage: Storage,
    private exercisesProvider: ExercisesProvider,
    private http: HttpClient
  ) {
    console.log('Hello Plan Provider');
  }

  saveCurrentDay(day: any) {
    this.storage.set('currentDay', JSON.stringify(day));
  }

  clearCurentDay() {
    this.storage.remove('currentDay');
  }

  loadCurrentDay() {
    return this.storage.get('currentDay');
  }

  getPlan() {
    let plan = importedPlan;
    for (let day of plan) {
      for (let i = 0; i < day.exercises.length; i++) {
        day.exercises[i] = this.exercisesProvider.getExercise(day.exercises[i]);
      }
    }
    return plan;
  }

  addHistory(exerciseId: string, newHistory: string) {
    this.exercisesProvider.updateHistory(exerciseId, newHistory);
  }

}



// WEBPACK FOOTER //
// ./src/providers/plan/plan.ts